import { Select } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setDeafultDealerCode } from "../../../redux/reducers/authSlice";

const ChangeDealerCode = (props) => {
  const dispatch = useDispatch();
  const authData = useSelector((state) => state.auth_store);
  const dealer_code = authData?.defaultDealerCode;
  const [dealerCodes, setDealerCodes] = useState([]);
  useEffect(() => {
    if (
      Array.isArray(authData.dealer_codes) &&
      authData.dealer_codes.length > 1
    ) {
      const dealerIds = authData?.dealer_codes?.map((it) => it.dealer_id);
      setDealerCodes(dealerIds);
    } else {
      // dispatch(setDeafultDealerCode(authData?.dealer_codes[0]?.dealer_id));
      // console.log(
      //   "The main dealer id is:",
      //   authData?.dealer_codes[0]?.dealer_id
      // );
    }
  }, [authData.dealer_codes]);
  console.log("Auth Data is:", authData);
  return (
    <>
      {Array.isArray(authData.dealer_codes) &&
        authData.dealer_codes.length > 1 && (
          <div className="flex justify-between items-center">
            <div className="font-semibold mr-2 max-sm:text-lg">
              Change Dealer Code:{" "}
            </div>
            <Select
              className="w-[100px]"
              value={dealer_code}
              onChange={(value) => {
                dispatch(setDeafultDealerCode(value));
              }}
              options={dealerCodes.map((item) => ({
                key: `${item}`,
                value: `${item}`,
                label: item,
              }))}
            />
          </div>
        )}
    </>
  );
};

export default ChangeDealerCode;
